import { UNAUTHORIZED } from 'http-status-codes';
import { logoutAndRedirect } from '../actions/global/auth';
import globals from '../globals/communityGlobals';

const locale = globals.getArea('accountLogin');
const errorMessages = globals.getArea('error');

export const authorisationExpiredAction = logoutAndRedirect({ failure: locale.getMsg('authorisationExpired') });

export function createAPIErrorHandler(dispatchers) {
  return error => {
    if (error.response && error.response.status === UNAUTHORIZED) {
      dispatchers.unauthorized();
    } else if (dispatchers.other && error.message.localeCompare(errorMessages.getMsg('cancelDuplicateRequest')) !== 0) {
      dispatchers.other(error);
      throw new Error(error);
    }
  };
}
